// extracted by mini-css-extract-plugin
export default {"ImgButton":"ImgButton_ImgButton__QBP3z","sendIcon":"ImgButton_sendIcon__b+JXa"};